/** @jsxImportSource @emotion/react */
import PrettyPrice from '../PrettyPrice';
import VisiblyHidden from '../VisiblyHidden';
import useStyle from './style';

const Price: React.FC<{
  salePrice?: number;
  price?: number;
  free?: boolean | string;
}> = ({ salePrice = 0, price = 0, free = false }) => {
  const s = useStyle();
  const discounted = salePrice < price;
  const zero = salePrice === 0;
  const negative = salePrice < 0;

  if (!!free) {
    let message = 'Free';
    if (typeof free === 'string') {
      message = free;
    }
    return (
      <span css={s.priceWrapper}>
        {!!price && (
          <>
            <p className="price" aria-hidden>
              <PrettyPrice price={price} />
            </p>
          </>
        )}
        <VisiblyHidden>{`Price: $${salePrice}`}</VisiblyHidden>
        <p className="free text-right">{message}</p>
      </span>
    );
  }

  return (
    <span css={s.priceWrapper}>
      {negative && (
        <>
          <p className="price negative" aria-hidden>
            <PrettyPrice price={salePrice} />
          </p>
          <VisiblyHidden>{`Removed $${Math.abs(
            salePrice
          )} from price`}</VisiblyHidden>
        </>
      )}
      {discounted && !negative && (
        <>
          <p className="strikethrough" aria-hidden>
            <PrettyPrice price={price} />
          </p>
          <p className={zero ? 'free' : 'sale-price'} aria-hidden>
            {zero ? 'Free' : <PrettyPrice price={salePrice} />}
          </p>
          <VisiblyHidden>
            {`Discounted price: Was $${price}, now only $${salePrice}.`}
          </VisiblyHidden>
        </>
      )}
      {!discounted && !negative && (
        <>
          <p className="free" aria-hidden>
            {zero ? (
              <PrettyPrice price={0} />
            ) : (
              <PrettyPrice price={salePrice} />
            )}
          </p>
          <VisiblyHidden>{`Price: $${salePrice}`}</VisiblyHidden>
        </>
      )}
    </span>
  );
};

export default Price;
